export default __webpack_public_path__ + "static/banner-lets-keep-healthy-over-christmas-20edee7391f13702b98813c5b363e857.jpg";